import { createContext as t } from "react";
import { SCALE_FACTOR as o } from "../../config/globalConstants.js";
const c = t({
  scaleFactor: o
});
export {
  c as ScaleContext
};
